import { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components"
import _ from 'lodash';
import { GoogleMap, MarkerF, Polyline, Circle, DirectionsRenderer, StreetViewPanorama, TrafficLayer } from '@react-google-maps/api';
import { useDispatch } from "react-redux";
import { setDetailsMarkerItem, setDetailsVisibleMarkers, settopPagesMapSingleShipmentItemLocationList } from "../../features/topPagesMap/topPagesMapSlice";
import { useMemo } from "react";
import avatar from "../../images/img/avatar.jpg"
import MemoizedOverlayDetailsMap from "./overlays/MemoizedOverlayDetailsMap";
import stopImg from "../../images/svg/topPages/stop.svg"
import bayrakk from "../../images/svg/bayrakk.svg"
import speedMarker from "../../helper/topPagesMap/speedMarker";
import dateTimeFormatter from "../../helper/date/dateTimeFormatter";

const Container = styled.div`
            width: calc(100% - 400px);
            position: relative;

            .active-marker-container{
                position: absolute;
                top: 15px;
                right: 15px;
                z-index: 20;
                display: flex;
                flex-direction: column;
                gap: 5px;

                width: 250px;
                height: 120px;
                border-radius: 10px;
                background-color: ${({theme}) => theme.mainBgColor};
                padding: 15px;
                color: ${({theme}) => theme.mainTextColor};
                border: 1px solid ${({theme}) => theme.mainTextColor};

                .marker-content-item{
                    display: flex;


                    .key{
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-xl);
                        padding-right: 6px;
                    }

                    .value{
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-md);
                    }
                }
            }
`


const circleOptions = {
    strokeColor: '#FF0000',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: '#FF0000',
    fillOpacity: 0.35,
    clickable: false,
    draggable: false,
    editable: false,
    visible: true,
    radius: 10000, // Çemberin yarıçapı (metre cinsinden)
    zIndex: 1
  };
    
function createKey(location) {
    return location.lat + location.lng + location.index
}

const TopPagesMapWideMap = () => {

    const dispatch = useDispatch()

    //! pastKonumId şu anda incelenen konum listesinin id si
    const {
        detailsVisibleMarkers,
        filterStartDate,
        filterEndDate,
        detailsMarkerItem,
        activeTabId,
        activeLocationOrderForAnimation,
        animationControlType,
        animationFocusType,
        liveStreetView,
        animationViewType,
        locationPointPauseFilter,
        maxSpeedValue,
        maxSpeedFilter,
        isTrafficLayer,

        topPagesMapSingleShipmentItemLocationList,
        topPagesMapShipmentItemCurrentLocationData,

    } = useSelector(state => state.topPagesMap)
    const {singleShipmentLoadItem} = useSelector(state => state.loadList)

    //! zoom seviyesini tutmak için
    const [zoom, setZoom] = useState(6)

    //! map object i
    const [map, setMap] = useState(null);

    //! bu Markerların scale dğerini tutan state
    const [scale, setScale] = useState(3)

    //! bu hartianın merkezi konumu
    const initialCenterRef = useRef({ lat: 39.419221, lng: 34.343262 });

    const [directionResponse, setDirectionResponse] = useState(null)


    //! bu ekranda gösterilecek olan
    const [showedList, setShowedList ] = useState([]) 

    useEffect(() => {
        
        const list = detailsVisibleMarkers?.map(item => {
            const locationPointPauseFilterPassed = (typeof item?.lastLocationTimeSpan === "number" ? parseInt(item?.lastLocationTimeSpan?.toString()?.replace("-", "")): 0) < 600 
            const maxSpeedPassed = parseInt(item.speed * 3.6) <= maxSpeedValue  
            let dateFilterPassed = true 
            
            if(filterStartDate && filterEndDate){
                dateFilterPassed = item?.createdDate >= filterStartDate && item?.createdDate <= filterEndDate
            }
            else if (filterStartDate && !filterEndDate){
                dateFilterPassed = item?.createdDate >= filterStartDate
            }

            else if(!filterStartDate && filterEndDate){
                dateFilterPassed = item?.createdDate <= filterEndDate
            }

            else{
                dateFilterPassed = true
            }

            if(locationPointPauseFilter && !locationPointPauseFilterPassed && dateFilterPassed && !maxSpeedFilter){

                return {
                    ...item,
                    type: 1
                }
            }

            else if(!locationPointPauseFilter && dateFilterPassed && !maxSpeedFilter){
                if(locationPointPauseFilterPassed){
                    return {
                        ...item,
                        type: 2
                    } 
                }

                else if(!locationPointPauseFilterPassed){
                    return {
                        ...item,
                        type: 3
                    }
                }

                else{
                    return null                    
                }
            }

            else if(!locationPointPauseFilter && dateFilterPassed && maxSpeedFilter){
                if(!maxSpeedPassed){
                    return {
                        ...item,
                        type: 4
                    }
                }
                else{
                    return null
                }
            }

            else{
                return null
            }
        })
        setShowedList(list?.filter(item => item !== null))

    },[detailsVisibleMarkers, locationPointPauseFilter, maxSpeedFilter, maxSpeedValue, filterStartDate, filterEndDate])


    //! bu ekranın kapsama alanında görünecek olan markerları ayarlıyor
    const handleBoundsChanged = useCallback(
        _.debounce(() => {
            if (map) {
                const bounds = map.getBounds();
                const visible = topPagesMapSingleShipmentItemLocationList?.filter(location =>
                  bounds.contains(new window.google.maps.LatLng({lat: parseFloat(location?.lat), lng: parseFloat(location?.lng)}))
                );
                dispatch(setDetailsVisibleMarkers(visible))
            }
        }, 200), // Debounce delay in milliseconds
        [map, topPagesMapSingleShipmentItemLocationList]
    );

    const handleZoomChanged = () => {
        if (map) {
            setZoom(map.getZoom())
          }
    }

    const handleMarkerClick = (item) => {
        dispatch(setDetailsMarkerItem(item))
    }


    //! bu rotanın parametrelerini ayarlayan
    // useEffect(() => {
    //     if(singleShipmentLoadItem?.id && topPagesMapSingleShipmentItemLocationList.length > 0){

    //       const origin = {
    //         lat: parseFloat(topPagesMapShipmentItemCurrentLocationData?.currentDriverLocation?.lat),
    //         lng: parseFloat(topPagesMapShipmentItemCurrentLocationData?.currentDriverLocation?.lng),
    //       };
    
    //       const waypoints = singleShipmentLoadItem.routePoints.$values.filter((_, i) => i !== 0 && i+1 !== singleShipmentLoadItem.routePoints.$values.length).filter(item => item.stateOfRoutePoint !== 2).map(item => {
    //         return {
    //           location: {
    //             lat: parseFloat(item.lat),
    //             lng: parseFloat(item.lng),
    //           }
    //         }
    //       }) 
    
    //       const destination = {
    //         lat: parseFloat(singleShipmentLoadItem?.routePoints?.$values[singleShipmentLoadItem?.routePoints?.$values?.length -1].lat),
    //         lng: parseFloat(singleShipmentLoadItem?.routePoints?.$values[singleShipmentLoadItem?.routePoints?.$values?.length -1].lng),
    //       }
    //       calculateRoute({origin, destination, waypoints})
    //     }
    //   },[singleShipmentLoadItem?.id, topPagesMapShipmentItemCurrentLocationData])


    // //! bu rotayı hesaplayan
    // const calculateRoute = async ({origin, destination ,waypoints }) => {
    //     console.log("buraya geliyor");

    //     // eslint-disable-next-line no-undef
    //     const directionsService = new google.maps.DirectionsService()
    //     const results = await directionsService.route({
    //         origin: origin,
    //         destination: destination,
    //         // eslint-disable-next-line no-undef
    //         travelMode: google.maps.TravelMode.DRIVING,
    //         waypoints: waypoints
    //     })
    //     setDirectionResponse(results)
    // }

    
    //! bu animasyonda o sırada gözüken marker (optimizasyon için useMemo kullanıldı)
    const markerMemo = useMemo(() => <MarkerF
      position={{
        lat: parseFloat(topPagesMapSingleShipmentItemLocationList[activeLocationOrderForAnimation]?.lat),
        lng: parseFloat(topPagesMapSingleShipmentItemLocationList[activeLocationOrderForAnimation]?.lng)
      }}
    />,
    [activeLocationOrderForAnimation]);

  return (
    <Container>
                {
                    detailsMarkerItem?.lat &&
                    <div className="active-marker-container">
                        <div className="marker-content-item">
                            <div className="key">Tarih: </div>
                            <div className="value">{dateTimeFormatter(detailsMarkerItem?.createdDate)?.date} - {dateTimeFormatter(detailsMarkerItem?.createdDate)?.time}</div>
                        </div>
                        <div className="marker-content-item">
                            <div className="key">Hız (km/sa): </div>
                            <div className="value">{detailsMarkerItem?.speed > 0 ? (detailsMarkerItem?.speed * 3.6 ).toFixed(0) : "---"}</div>
                        </div>
                        <div className="marker-content-item">
                            <div className="key">Şarj Yüzdesi: </div>
                            <div className="value">%{parseInt(detailsMarkerItem?.batteryLevel * 100)}</div>
                        </div>
                        {
                            (locationPointPauseFilter && detailsMarkerItem?.type === 1) &&
                            <div className="marker-content-item">
                                <div className="key" style={{paddingTop: "10px", textDecoration: "underline", cursor: "pointer"}}>
                                    Sokak Görünümünden Çık
                                </div>
                            </div>
                        }
                    </div>
                }
                {/* {
                  (activeTabId === 2 && topPagesMapSingleShipmentItemLocationList[activeLocationOrderForAnimation]) &&
                  <div className="active-marker-container">
                    <div className="marker-content-item">
                        <div className="key">Tarih: </div>
                        <div className="value">{topPagesMapSingleShipmentItemLocationList[activeLocationOrderForAnimation]?.createdDate && getPastDateAndTime(topPagesMapSingleShipmentItemLocationList[activeLocationOrderForAnimation]?.createdDate)?.formattedDate}  {topPagesMapSingleShipmentItemLocationList[activeLocationOrderForAnimation]?.createdDate && getPastDateAndTime(topPagesMapSingleShipmentItemLocationList[activeLocationOrderForAnimation]?.createdDate)?.formattedTime}</div>
                    </div>
                    <div className="marker-content-item">
                        <div className="key">Hız (km/sa): </div>
                        <div className="value">{topPagesMapSingleShipmentItemLocationList[activeLocationOrderForAnimation].speed > 0 ? (topPagesMapSingleShipmentItemLocationList[activeLocationOrderForAnimation].speed * 3.6).toFixed(0) : "---"}</div>
                    </div>
                    <div className="marker-content-item">
                        <div className="key">Şarj Yüzdesi: </div>
                        <div className="value">%{parseInt(topPagesMapSingleShipmentItemLocationList[activeLocationOrderForAnimation].batteryLevel * 100)}</div>
                    </div>
                    <div className="marker-content-item">
                        <div className="key">Tarih: </div>
                        <div className="value"></div>
                    </div>
                </div>
                } */}

                <GoogleMap
                    center={animationFocusType ? topPagesMapSingleShipmentItemLocationList[activeLocationOrderForAnimation] : initialCenterRef.current}
                    zoom={6}
                    mapContainerStyle={{ height: "100%", width: "100%" }}
                    onBoundsChanged={handleBoundsChanged}
                    onLoad={map => setMap(map)}
                    onZoomChanged={handleZoomChanged}
                    options={{
                        fullscreenControl: false, // Tam ekran kontrolünü kapatır
                        streetViewControl: false, // Sokak görünümü kontrolünü kapatır
                        mapTypeControl: false, // Harita tipi kontrolünü kapatır
                        zoomControl: false, // Zoom kontrolünü kapatır
                        gestureHandling: "greedy" // ctrl olayını kapatır
                    }}
                >

                {/* //! eğer güncel verilerin gözükeceği tab ise */}
                {
                    activeTabId === 1 && 
                    <>
                    {/* //! canlı sokak görünümü ise */}
                    <StreetViewPanorama
                        position={{lat: parseFloat(topPagesMapSingleShipmentItemLocationList[topPagesMapSingleShipmentItemLocationList.length-1].lat), lng: parseFloat(topPagesMapSingleShipmentItemLocationList[topPagesMapSingleShipmentItemLocationList.length-1].lng)}}
                        visible={liveStreetView}
                        options={{
                            pov: { heading: 100, pitch: 0 },
                            zoom: 1,
                            enableCloseButton: false
                        }}
                    />
                    {
                        isTrafficLayer &&
                        <TrafficLayer />
                    }


                    {/* //! bu sürücünün gitmesi gerek yolu gösteren direction */}
                    {
                        (singleShipmentLoadItem?.id && directionResponse) && (
                        <DirectionsRenderer directions={directionResponse} options={{
                            suppressMarkers: true,
                            polylineOptions: {
                                strokeColor: "#1d1c1c",
                                strokeOpacity: isTrafficLayer ? 0.6 : 1,
                                strokeWeight: 5,
                                fillColor: '#E85446',
                                fillOpacity: 0.35,
                            },
                          }}/>
                        )
                    }


                    {
                        //! bu sürücünün yol aldığı kısmı gösteren polyline
                        singleShipmentLoadItem?.id &&
                        <Polyline
                            path={topPagesMapSingleShipmentItemLocationList}
                            options={{
                            strokeColor: '#E85446',
                            strokeOpacity: isTrafficLayer ? 0.6 : 1,
                            strokeWeight: 5,
                            fillColor: '#E85446',
                            fillOpacity: 0.35,
                            clickable: false,
                            draggable: false,
                            editable: false,
                            visible: true,
                            radius: 30000,
                            paths: topPagesMapSingleShipmentItemLocationList,
                            zIndex: 1,
                            }}
                        />
                    }

                    {/* //! bu sürücünün son konumunu gösteren overlay */}
                    <MemoizedOverlayDetailsMap
                        position={{lat: parseFloat(topPagesMapShipmentItemCurrentLocationData?.currentDriverLocation?.lat), lng: parseFloat(topPagesMapShipmentItemCurrentLocationData?.currentDriverLocation?.lng)}}
                        imageUrl={topPagesMapShipmentItemCurrentLocationData?.driverInfo?.profilePhoto ? `${process.env.REACT_APP_API_IMG_URI}${topPagesMapShipmentItemCurrentLocationData?.driverInfo?.profilePhoto}`: avatar}
                        animationControlType={animationControlType}
                    />

                    <MarkerF
                        icon={{
                            url: bayrakk,
                            anchor: new window.google.maps.Point(0, 32),
                            size: new window.google.maps.Size(20, 32),
                            origin: new window.google.maps.Point(0, 0),
                        }}
                        onClick={() => {}}
                        position={{ lat: parseFloat(singleShipmentLoadItem.routePoints.$values[singleShipmentLoadItem.routePoints.$values.length-1].lat), lng: parseFloat(singleShipmentLoadItem.routePoints.$values[singleShipmentLoadItem.routePoints.$values.length-1].lng) }}
                    />

                    <MarkerF
                        icon={{
                            url: bayrakk,
                            anchor: new window.google.maps.Point(0, 32),
                            size: new window.google.maps.Size(20, 32),
                            origin: new window.google.maps.Point(0, 0),
                        }}
                        onClick={() => {}}
                        position={{
                            lat: parseFloat(singleShipmentLoadItem.routePoints.$values[0].lat),
                            lng: parseFloat(singleShipmentLoadItem.routePoints.$values[0].lng)
                        }}
                    />
                </>
                }

            {/* //! eğer animasyonlu kısım ise burası rotanın çizgi olarak gösterilmesini sağlıyor -------------------------------------------------------------------------------------------------------------------------------------------------------------------- */}
            {
            (activeTabId === 2 && animationViewType === "route") &&
                <Polyline
                    path={topPagesMapSingleShipmentItemLocationList.map(item => {
                        return {
                            lat: parseFloat(item?.lat),
                            lng: parseFloat(item?.lng)
                        }
                    })}
                    options={{
                    strokeColor: '#E85446',
                    strokeOpacity: 1,
                    strokeWeight: 5,
                    fillColor: '#E85446',
                    fillOpacity: 0.35,
                    clickable: false,
                    draggable: false,
                    editable: false,
                    visible: true,
                    radius: 30000,
                    paths: topPagesMapSingleShipmentItemLocationList,
                    zIndex: 1,
                    }}
                />
            }

            {/* //! animasyonda o sırada gözüken marker (optimizasyon için useMemo kullanıldı) -------------------------------------------------------------------------------------------------------------------------------------------------------------------- */}
            {(activeTabId === 2 && animationViewType === "route") &&
                markerMemo
            }

            {/* //! animasyonda iconik görünümde görünen markerlar-------------------------------------------------------------------------------------------------------------------------------------------------------------------- */}
                {(activeTabId === 2 && animationViewType === "icon") && showedList?.map((item, i) => {

                    //! ilk if
                    if(item.type === 1){
                        return (
                            <MarkerF
                                icon={{
                                    scale: scale,
                                    fillColor: '#E85446',
                                    fillOpacity: 1,
                                    strokeWeight: 2,
                                    rotation: item?.heading,
                                    strokeColor: "#E85446",
                                    url: stopImg
                                }}
                                key={createKey({lat: parseFloat(item.lat), lng: parseFloat(item.lng), index: i})}
                                onClick={() => handleMarkerClick(item)}
                                position={{lat: parseFloat(item.lat), lng: parseFloat(item.lng)}}
                            />
                        )
                    }

                    //! ikinci if
                    else if(item.type === 2){
                        return (
                            <MarkerF
                                icon={{
                                    scale: scale,
                                    fillColor: '#E85446',
                                    fillOpacity: 1,
                                    strokeWeight: 2,
                                    rotation: item?.heading,
                                    strokeColor: "#E85446",
                                    path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW
                                }}
                                key={createKey({lat: parseFloat(item.lat), lng: parseFloat(item.lng), index: i})}
                                onClick={() => handleMarkerClick(item)}
                                position={{lat: parseFloat(item.lat), lng: parseFloat(item.lng)}}
                            />
                        )
                    }
                    else if(item.type === 3){
                        return (
                            <MarkerF
                                icon={{
                                    scale: scale,
                                    fillColor: '#E85446',
                                    fillOpacity: 1,
                                    strokeWeight: 2,
                                    rotation: item?.heading,
                                    strokeColor: "#E85446",
                                    url: stopImg
                                }}
                                key={createKey({lat: parseFloat(item.lat), lng: parseFloat(item.lng), index: i})}
                                onClick={() => handleMarkerClick(item)}
                                position={{lat: parseFloat(item.lat), lng: parseFloat(item.lng)}}
                            />
                        )   
                    }

                    //! üçüncü if
                    else if(item.type === 4){
                            return (
                                <MarkerF
                                    icon={{
                                        fillColor: '#E85446',
                                        fillOpacity: 1,
                                        strokeWeight: 2,
                                        rotation: item?.heading,
                                        strokeColor: "#E85446",
                                        url: speedMarker(parseInt(item.speed * 3.6), parseInt(item.speed * 3.6) <= 80 ? "#1f8216" : "#E85446"),
                                        anchor: new window.google.maps.Point(15, 15), // Marker'ın ortasını konumla eşleştirmek için
                                        origin: new window.google.maps.Point(0, 0),   // Başlangıç noktası
                                        scaledSize: new window.google.maps.Size(30, 30), // SVG boyutu
                                    }}
                                    key={createKey({lat: parseFloat(item.lat), lng: parseFloat(item.lng), index: i})}
                                    onClick={() => handleMarkerClick(item)}
                                    position={{lat: parseFloat(item.lat), lng: parseFloat(item.lng)}}
                                />
                            )
                        }
                    } 
                )}

            {
                (detailsMarkerItem?.lat && detailsMarkerItem?.lng) &&
                    <StreetViewPanorama
                        position={{lat: parseFloat(detailsMarkerItem?.lat), lng: parseFloat(detailsMarkerItem?.lng)}}
                        visible={locationPointPauseFilter && detailsMarkerItem?.type === 1}
                        options={{
                            pov: { heading: 100, pitch: 0 },
                            zoom: 1,
                            enableCloseButton: false
                        }}
                    />
            }

            {/* //! bu rota noktalarını gösteren circle-------------------------------------------------------------------------------------------------------------------------------------------------------------------- */}
            {singleShipmentLoadItem.routePoints.$values.map((item) => (
                <Circle
                center={{lat: parseFloat(item.lat.replace(",", ".")), lng: parseFloat(item.lng.replace(",", "."))}}
                options={circleOptions} // Çemberin özelliklerini buradan ayarlayın
                />
            ))}


        {/* //! bu sürücünün son konumunu göseren */}
        {/* <MemoizedOverlayDetailsMap position={{lat: parseFloat(topPagesMapSingleShipmentItemLocationList[topPagesMapSingleShipmentItemLocationList.length-1].lat), lng: parseFloat(topPagesMapSingleShipmentItemLocationList[topPagesMapSingleShipmentItemLocationList.length-1].lng)}} imageUrl={singleShipmentLoadItem.userProfilePhoto ? `${process.env.REACT_APP_API_IMG_URI}${singleShipmentLoadItem.userProfilePhoto}`: avatar} animationControlType={animationControlType}/> */}
   
    </GoogleMap>
</Container>
  )
}

export default TopPagesMapWideMap